import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { CartProvider } from "./store";
import { CityProvider } from "./city";
import "./styles.css";
import { WorldExperienceProvider } from "./world/WorldExperienceProvider";
import "./world/world.css";
import "./phase4f.css";
import "./world/travel.css";
import "./world/visual-pack.css";
import "./phase4f-districts.css";
import "./home/home.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <WorldExperienceProvider>
        <CityProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </CityProvider>
      </WorldExperienceProvider>
    </BrowserRouter>
  </StrictMode>,
);
